import { HTMLAttributes, useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

import { Button } from "../../../../Components/Button";
import { useUser } from "../../../../Hooks/useUser";

import { analytics } from "MVVM/Analytics";
import { PlayViewModel } from "../../Views/Play/ViewModel";

interface IJoinCampaignButtonProps extends HTMLAttributes<HTMLButtonElement> {
  color: string;
  secondaryColor?: string;
  slug: string;
  width?: string;
}

export const JoinCampaignButton = ({
  color,
  secondaryColor,
  slug,
  width,
  ...props
}: IJoinCampaignButtonProps) => {
  const history = useHistory();
  const { allstarUser } = useUser();
  const { getViewerLeaderboardDetails } = PlayViewModel(slug);

  const [hasJoined, setHasJoined] = useState(false);

  useEffect(() => {
    const fetchLeaderboardDetails = async () => {
      const { data } = await getViewerLeaderboardDetails({
        variables: { slug },
      });
      const rank = data?.campaign?.leaderboardDetails?.viewerContestant?.rank;
      if (typeof rank === "number" && rank > 0) setHasJoined(true);
    };
    fetchLeaderboardDetails();
  }, [getViewerLeaderboardDetails, slug]);

  return (
    <StyledButton
      size="default"
      width={width}
      color={color}
      textColor={secondaryColor}
      {...props}
      onClick={async () => {
        if (hasJoined) analytics.track("Competition Widget - Visit Click", {});
        else analytics.track("Competition Widget - Join Click", {});

        if (!allstarUser.loggedIn)
          return history.push(`/login?next=${window.location.pathname}`);

        return history.push(`/competitions/${slug}`);
      }}
    >
      {hasJoined ? "Visit Competition" : "Join Competition"}
    </StyledButton>
  );
};
const StyledButton = styled(Button)<{ color: string; width: string }>`
  color: ${({ textColor, theme }) => textColor || theme.colors.ice};

  z-index: 2;
  font-size: ${({ theme }) => theme.text.subheader.fontSize};

  width: ${(props) => props.width || "200px"};
  background: ${(props) => props.color};

  :hover {
    background: ${(props) => props.color};
    filter: brightness(90%);
  }
`;
